import React from "react";
import T from "prop-types";

export default function Row({
  label,
  value,
  renderIfPresent = false,
  align = "text-right"
}) {
  if (renderIfPresent) {
    if (!value) return false;
  }

  return (
    <tr>
      <th className={align}>{label}</th>
      <td>{value}</td>
    </tr>
  );
}

Row.propTypes = {
  align: T.string,
  label: T.string.isRequired,
  value: T.oneOfType([T.node, T.arrayOf(T.node)]),
  renderIfPresent: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/DetailTable/Detail.jsx